/**
 * @module app.pp
 */

import { autoinject, bindable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { AuthContext } from 'app/um/lib/auth-context';
import { WizardNavigator } from 'app/core/components/wizard/wizard-navigator';
import { IWizardStep } from 'app/core/components/wizard/interfaces';
import { EssAccordionCustomAttribute } from 'app/shared/attributes/ess-collapse-attributes';
import { EventAggregator } from 'aurelia-event-aggregator';
import { SaveAuthDetailsEvent } from 'app/pp/lib/events';
import { UpdateAuthDetailsStep } from 'app/pp/components/update/update-auth-details-step';
import { IAuthChangeCustomEventDetail } from 'app/um/lib/events'
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class UpdateAuthRequest extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable({ changeHandler: 'configure' })
    protected authId: string | null = null;

    protected auth: UM.Auth | null = null;

    public latestStepIndex: number = 0;

    ////****************** Element References ***************************************////
    protected $collapsible!: EssAccordionCustomAttribute;
    protected $wizard!: WizardNavigator;
    protected $steps: IWizardStep[] = [];

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly events: EventAggregator,
        private readonly context: AuthContext,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        if(!this.authId) this.logger.warn('Bindable property [authId] was not set at binding');
    }

    ////****************** Events ***************************************************////
    public async reload({ authReloaded, triggerRules }: IAuthChangeCustomEventDetail): Promise<void> {
        if(!authReloaded && this.auth?.id) {
            await this.context.refreshAuthSettings(this.auth);
        }
    }

    ////****************** Functions ************************************************////
    protected async configure(): Promise<void> {
        this.auth = null;
        if(!this.authId) return;

        this.latestStepIndex = 0;
        if(this.$wizard) this.$wizard.reset();
        if(this.$collapsible) this.$collapsible.open(0);

        await this.context.configure(this.authId);
        this.auth = this.context.auth;
    }

    public saveAuthDetails(): void {
        this.events.publish(new SaveAuthDetailsEvent(false));
    }

    public continue(): void {
        if(this.latestStepIndex === 0) this.events.publish(new SaveAuthDetailsEvent(true));
        if(this.$wizard && !!this.$steps[this.latestStepIndex + 1]) this.$wizard.continueToNextSection();
    }

    public hasPendingChanges(): boolean {
        const updateAuthDetailsStep = <any>this.$steps[0] as UpdateAuthDetailsStep;
        return !!updateAuthDetailsStep.hasChanges();
    }

    protected isSectionEnabled(item: Element): boolean {
        if(!this.authId) return false;

        return this.$wizard?.isSectionEnabled(item);
    }


    ////****************** Service Calls ********************************************////

}
